import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import SiteBannerLayout from "@openstack_dev/gatsby-theme-marketing-oif-core/src/components/SiteBannerLayout";
import { Box, Container, Stack, Typography } from "@mui/material";
import SoftwareNavBar from "@/components/pages/Software/SoftwareNavBar";

import styles from "./index.module.scss";

const SoftwareLayoutTemplate = ({ data, children }) => {
  const { pageTitle, navBar } = data;

  return (
    <SiteBannerLayout>
      <Stack sx={{ width: "100%", marginTop: "20px" }}>
        <Typography variant="h1">{pageTitle}</Typography>
        <SoftwareNavBar links={navBar} />
        <Box className={styles.softwareContentWrapper}>
          <Container maxWidth="xl" className={styles.softwareContent}>
            {children}
          </Container>
        </Box>
      </Stack>
    </SiteBannerLayout>
  );
};

SoftwareLayoutTemplate.propTypes = {
  data: PropTypes.shape({
    pageTitle: PropTypes.string.isRequired,
    navBar: SoftwareNavBar.propTypes.links
  }).isRequired,
  children: PropTypes.node.isRequired
};

const dataQuery = graphql`
  query {
    softwareJson {
      pageTitle
      navBar {
        title
        url
        subLinks {
          title
          url
        }
      }
    }
  }
`;

const SoftwareLayout = ({ children }) => {
  const { softwareJson } = useStaticQuery(dataQuery);

  return (
    <SoftwareLayoutTemplate data={softwareJson}>
      {children}
    </SoftwareLayoutTemplate>
  );
};

SoftwareLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default SoftwareLayout;
